/**
 * Temporary inventory-page UI switches.
 * Keep related theme/toggle code wired so these can be re-enabled later without rewrites.
 */
export const INVENTORY_UI_FLAGS = {
  /**
   * When true: honor user/device light|dark preference and show the theme toggle.
   * When false: always show the light theme and hide the toggle (dark theme stays in code).
   */
  enableDarkTheme: false,
  /**
   * When true: news page uses the dark theme.
   * When false: news page uses the light theme (dark styles stay in code for re-enable).
   */
  enableNewsDarkTheme: false,
  /**
   * When true: events page uses the dark theme.
   * When false: events page uses the light theme (dark styles stay in code for re-enable).
   */
  enableEventsDarkTheme: false,
  /**
   * When true: onboarding page uses the dark theme.
   * When false: onboarding page uses the light theme (dark styles stay in code for re-enable).
   */
  enableOnboardingDarkTheme: false,
};

/**
 * News page light chrome (search, cards, logged-in action bar).
 * While news dark theme is disabled, always light.
 */
export function isNewsPageLightTheme() {
  return !INVENTORY_UI_FLAGS.enableNewsDarkTheme;
}

/**
 * Events page light chrome (search, filters, date range, logged-in action bar).
 * Event cards keep their dark styling in both themes.
 * While events dark theme is disabled, always light.
 */
export function isEventsPageLightTheme() {
  return !INVENTORY_UI_FLAGS.enableEventsDarkTheme;
}

/**
 * Onboarding page light chrome (page background, card, option buttons, logo).
 * While onboarding dark theme is disabled, always light.
 */
export function isOnboardingPageLightTheme() {
  return !INVENTORY_UI_FLAGS.enableOnboardingDarkTheme;
}

/**
 * Light chrome for inventory offer-flow pages (request quote, make offer, get specs).
 * While dark inventory theme is disabled, these flows are always light.
 * When re-enabled, light only for the product-detail entry path (legacy behavior).
 */
export function isOfferFlowLightTheme(source) {
  if (!INVENTORY_UI_FLAGS.enableDarkTheme) {
    return true;
  }
  return source === 'productPage';
}

/**
 * "Give us a ring" / CallScreeningDialog and Set Price Alert chrome.
 * While dark inventory theme is disabled, always light (even outside InventoryThemeProvider).
 * When re-enabled, follow inventory light|dark preference.
 */
export function isCallScreeningLightTheme(theme) {
  if (!INVENTORY_UI_FLAGS.enableDarkTheme) {
    return true;
  }
  return theme?.palette?.type === 'light';
}
